import React, { useEffect } from 'react';
import { Dialog, Divider, Link, Sheet } from '@paypalcorp/pp-react';
import { PASSWORD, SEND_OTP } from '../common/views';
import { isMobile } from '../common/utils';
import { handlePomaUserRecovery } from './common';
import { PREFERRED_LOGIN_TYPES } from './constants';
const { OTP_LOGIN, PASSWORD_LOGIN } = PREFERRED_LOGIN_TYPES;
export default ({ applePayButtonSeen, authEventHandler, authProviderContext, isPomaUser, localizedContent, loadStartTime, logger, options = {}, publicCredential, publicCredentialType, setShowTryAnotherWay, setView, view, csrf, sessionID, setLoginPreferenceInCookie, }) => {
    useEffect(() => {
        logger.track('try_another_way_rendered');
        authEventHandler({
            event: 'tryAnotherWayPageRendered',
        });
    }, []);
    const Options = () => (React.createElement(React.Fragment, null,
        React.createElement("h4", { style: { marginBottom: '16px' } }, localizedContent('tryAnotherWay')),
        React.createElement(Divider, { style: { margin: '16px 0' } }),
        view === PASSWORD && (React.createElement(Link, { id: "tawLoginWithOtpLink", "data-testid": "taw-login-with-otp-link", href: "#", onClick: (e) => {
                e.preventDefault();
                logger.track('login_with_otp_clicked');
                setLoginPreferenceInCookie({ csrf, sessionID, preference: OTP_LOGIN });
                setView(SEND_OTP);
                setShowTryAnotherWay(false);
            } }, localizedContent('loginWithOtp'))),
        view !== PASSWORD && (React.createElement(Link, { id: "tawLoginWithPwdLink", "data-testid": "taw-login-with-pwd-link", href: "#", onClick: (e) => {
                e.preventDefault();
                if (isPomaUser) {
                    logger.track('setup_pwd_clicked');
                    handlePomaUserRecovery({ authProviderContext, authEventHandler, email: publicCredential, options });
                }
                else {
                    logger.track('login_with_pwd_clicked');
                    setLoginPreferenceInCookie({ csrf, sessionID, preference: PASSWORD_LOGIN });
                    setView(PASSWORD);
                    setShowTryAnotherWay(false);
                }
            } }, localizedContent(isPomaUser ? 'setupPassword' : 'loginWithPassword'))),
        React.createElement(Divider, { style: { margin: '16px 0' } }),
        React.createElement(Link, { id: "tawGuestCheckoutLink", "data-testid": "taw-guest-checkout-link", href: "#", onClick: (e) => {
                e.preventDefault();
                logger.track('create_account_clicked');
                logger.track(`cpl_cit_taw_guest_checkout|${JSON.stringify({
                    start: loadStartTime,
                    tt: Date.now() - loadStartTime,
                    login_experience: 'user opted out redirect',
                })}`);
                logger.flush({ csrf, sessionID });
                authEventHandler({
                    event: 'userOptedOut',
                    data: {
                        email: publicCredential,
                        publicCredentialType,
                        applePayButtonSeen,
                    },
                });
            } }, localizedContent(options.signupContent || 'createAccount'))));
    if (isMobile()) {
        // Mobile uses the Sheet component
        return (React.createElement(React.Fragment, null,
            React.createElement(Sheet, { isOpen: true, onClose: () => {
                    setShowTryAnotherWay(false);
                }, style: { textAlign: 'center' }, id: "tryAnotherWayContainer", "data-testid": "try-another-way-container" },
                React.createElement(Options, null))));
    }
    else {
        return (React.createElement(React.Fragment, null,
            React.createElement(Dialog, { isOpen: true, onClose: () => {
                    logger.track('try_another_way_closed');
                    setShowTryAnotherWay(false);
                }, style: { textAlign: 'center', paddingBottom: '60px' }, id: "tryAnotherWayContainer", "data-testid": "try-another-way-container" },
                React.createElement(Options, null))));
    }
};
